import classNames from 'classnames';
import { generatePath } from 'react-router-dom';
import { t } from 'ttag';

import { Title } from '@ui/Title';
import { LocalizedLink } from '@ui/LocalizedLink';
import * as legacyUrls from '@legacyUrls';

import s from './SeoCatalogAlsoSearch.sss';

type Tag = {
  id: number
  slug: string
  title: string
};

export type SeoCatalogAlsoSearchProps = {
  tags: Tag[]
  className?: string
};

export const SeoCatalogAlsoSearch: React.FC<SeoCatalogAlsoSearchProps> = ({
  tags,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <Title type="h3">
      {t`Також шукають`}
    </Title>

    <div className={s.tags}>
      {
        tags.map(
          (tag) => {
            if (tag.slug) {
              return (
                <LocalizedLink
                  key={tag.id}
                  className={s.link}
                  theme="black"
                  href={generatePath(legacyUrls.tag, { slug: tag.slug })}
                >
                  {tag.title}
                </LocalizedLink>
              );
            }

            return null;
          },
        )
      }
    </div>
  </div>
);
